import PhraseLoader from "components/SuperLesson/PhraseLoader";
import { get } from "lodash";
import React, { useEffect, useState } from "react";

const AILoader = ({ open, loader, from, currentUser  }) => {
  const isCanvasUser = !!get(currentUser, "canvas_id");
  const [openDropDown, setOpenDropDown] = useState({
    gradeLevel: false,
    state: false,
    timeFrame: false,
    days: false,
    standard: false,
    activities: false,
  });

  const updateState = (name, value) => {
    setOpenDropDown((prev) => ({ ...prev, [name]: value }));
  };

  const handleMenuClose = (value) => {
    updateState(value, false);
  };

  const handleScroll = () => {
    const openKeys = Object.keys(openDropDown).filter(
      (key) => openDropDown[key]
    );
    if (openKeys.length) {
      openKeys.forEach((key) => handleMenuClose(key));
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [openDropDown]);

  return (
    <>
      {open && (
        <div
          className={
            isCanvasUser ? "canvasuperLessionModal" : "superLessionModal"
          }
        >
          <div
            className={`createMyLession ${
              from !== "ebook" ? "create-lesson-modal" : "create-lesson-modals"
            } ${loader ? "createMyLessonLoader" : ""}`}
          >
            <div className="super-lesson-waiting">
              <PhraseLoader />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AILoader;
